import {
  Box,
  Flex,
  Heading,
  Text,
  Stack,
  Container,
  Avatar,
  useColorModeValue,
} from '@chakra-ui/react';

import SocialButtons from '../components/socialButtons/SocialButtons'

import Matilda from '../assets/images/team/Matilda.jpg'
import Kate from '../assets/images/team/Kate.jpg'
import Cameron from '../assets/images/team/Cameron.jpg'
import Alex from '../assets/images/team/Alex.jpg'
import Ben from '../assets/images/team/Ben.jpg'

const Testimonial = ({ children }) => {
  return <Box>{children}</Box>;
};

const TestimonialAvatar = ({
  src,
  name,
  title,
  socials,
}) => {
  return (
    <Flex align={'center'} mt={8} direction={'column'}>
      <Avatar src={src} alt={name} mb={2} style={{width: "96px",height: "96px"}}/>
      <Stack spacing={-1} align={'center'}>
        <Text fontWeight={600}>{name}</Text>
        <Text fontSize={'sm'} color={useColorModeValue('gray.600', 'gray.400')} align={'center'}>
          {title}
        </Text>
        <SocialButtons
          linkedin={socials.linkedin}
          github={socials.github}
          twitter={socials.twitter}
          link={socials.link}
        />
      </Stack>
    </Flex>
  );
};

const TestimonialItem = ({
  imgSrc,
  name,
  title,
  socials,
}) => {
  return (
    <span className="team-member">
      <Testimonial>
        <TestimonialAvatar
          src={imgSrc}
          name={name}
          title={title}
          socials={socials}
        />
      </Testimonial>
    </span>
  );
};

const teamMembers = [
  {
    name: 'Matilda Morton',
    imgSrc: Matilda,
    title: 'Junior Software Engineer & Coder Academy Student',
    socials: {
      linkedin: 'https://www.linkedin.com/in/matildamorton/',
      github: 'https://github.com/matildamort',
      twitter: 'https://twitter.com/Matilda74190430',
    },
  },
  {
    name: 'Kate McAlpine',
    imgSrc: Kate,
    title: 'Engineering Student / Sessional Academic',
    socials: {
      linkedin: 'https://www.linkedin.com/in/kate-mcalpine/',
      github: 'https://github.com/katemcalpine',
    },
  },
  {
    name: 'Cameron Jones',
    imgSrc: Cameron,
    title: 'Junior Software Engineer & Coder Academy Student',
    socials: {
      linkedin: 'https://www.linkedin.com/in/iamcrjones/',
      github: 'https://github.com/iamcrjones',
    },
  },
  {
    name: 'Alex Leybourne',
    imgSrc: Alex,
    title: 'Developer @ Entain Australia',
    socials: {
      linkedin: 'https://www.linkedin.com/in/alexleybourne/',
      twitter: 'https://twitter.com/AlexLeybourne',
      github: 'https://github.com/alexleybourne',
    },
  },
  {
    name: 'Ben Elsom',
    imgSrc: Ben,
    title: 'Junior Developer @ Entain Australia',
    socials: {
      linkedin: 'https://www.linkedin.com/in/benelsom/',
      github: 'https://github.com/Ben-Elsom',
      link: 'https://www.benelsom.com/',
    },
  },
]

export default function WithSpeechBubbles() {
  return (
    <div className="about-page page">
      <Box p={6}>
        <Stack spacing={0} align={'center'}>
            <Heading className='text-focus-in' color={'brand.main'}>The Idea</Heading>
          </Stack>
        <Text className="fade-in-bottom-1" color={'gray.600'} fontSize={'m'} style={{margin: "1rem", textAlign: 'center'}}>
            While brainstorming about ideas for an application for the Women In Digital Stream as part of the
            Entain Connectathon 2022, It was extremely apparent that there were struggles that those who do not identify as women
            are unaware of.
        </Text>
      </Box>
      <Box p={6}>
        <Stack spacing={12} align={'center'}>
          <Heading className='text-focus-in-1' color={'brand.main'}>Enter ally</Heading>
        </Stack>
        <Text className="fade-in-bottom-2" color={'gray.600'} fontSize={'m'} style={{margin: "1rem", textAlign: 'center'}}>
            ally attempts to bridge this gap with a two-pronged approach by providing support for women & gender diverse people in the workplace, but also help those who do not deal with the same struggles become more aware of the situations present.
        </Text>
        <Text className="fade-in-bottom-2" color={'gray.600'} fontSize={'m'} style={{margin: "1rem", textAlign: 'center'}}>
            The more that people are aware of the struggles that other people go through and situations that make them uncomfortable, the less likely for these situations to occur in the first place and creates a more inclusive environment for all.
        </Text>
      </Box>
      <Box>
        <Container maxW={'7xl'} py={6} as={Stack} spacing={10}>
          <Stack spacing={0} align={'center'}>
            <Heading className='text-focus-in-3' color={'brand.main'}>Our Team</Heading>
          </Stack>
          <Stack
            className="team fade-in-bottom-3"
            direction={{ base: 'column', md: 'row' }}
            spacing={{ base: 10, md: 4, lg: 10 }}
          >
          {teamMembers.map((member) => (
            <TestimonialItem
              key={member.name}
              imgSrc={member.imgSrc}
              name={member.name}
              title={member.title}
              socials={member.socials}
            />
          ))}
          </Stack>
        </Container>
      </Box>
    </div>
  );
}